import React from "react";

import { SongList } from "@components/Song";

export default function SongIndex({ locationId }) {
  return <SongList locationId={locationId} />;
}
